import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {INgxMyDpOptions} from 'ngx-mydatepicker';
import {Observable} from 'rxjs/Observable';
import {of} from 'rxjs/observable/of';
import {catchError, map, merge} from 'rxjs/operators';
import {FlashService} from '../../flash/flash.service';
import {ActivityService} from '../../services/activity.service';
import {ProjectService} from '../../services/project.service';
import {TimesheetService} from '../../services/timesheet.service';
import {PapaParseService} from 'ngx-papaparse';


@Component({
  selector: 'app-create-timesheet',
  templateUrl: './import-timesheet.component.html',
  styleUrls: ['./import-timesheet.component.css'],
})
export class ImportTimesheetComponent implements OnInit {

  importForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private projectService: ProjectService,
    private timesheetService: TimesheetService,
    private flashService: FlashService,
    private router: Router,
    private activityService: ActivityService,
    private papa: PapaParseService,
    private loader: Ng4LoadingSpinnerService
  ) { }
  public projects$: Observable<any>;
  public activities$: Observable<any>;
  public parsing = false;
  public loading = false;
  public total = 0;
  public success = 0;
  public failed = [];
  currentUser;
  defaultProjects:any = [];
  hideBilledHours:boolean = false;
  myOptions: INgxMyDpOptions = {
    dateFormat: 'mmm dd, yyyy',
    showTodayBtn: false,
    yearSelector: false,
    sunHighlight: false,
    showSelectorArrow: false,
    alignSelectorRight: false,
    firstDayOfWeek: 'su'
  };
  ngOnInit() {
    this.projects$ = this.projectService.getProjects()
      .pipe(map(response => response['body']['result']),
        catchError(error => of([])));
    this.activities$ = this.activityService.getActivities()
      .pipe(map(response => response['body']['result']),
        catchError(error => of([])));
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const date = new Date();
    this.importForm = this.formBuilder.group({
      'account_id': this.currentUser.id,
      'project_id': ['', Validators.required],
      'activity_id': ['', Validators.required],
      'file': ['', Validators.required]
    });
  }
  validateFormGroup(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
          control.markAsTouched({
              onlySelf: true
          });
      } else if (control instanceof FormGroup) {
          this.validateFormGroup(control);
      }
    });
  }
  fileUploaded($event) {
    if(!$event.target.files || $event.target.files.length <= 0) {
      return false;
    }
    this.parsing = true;
    const file = $event.target.files[0];
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = (event) => {
      const csvData:any = event.target['result'];
      const data = this.papa.parse(csvData, {header: true, skipEmptyLines: true});
      this.importForm.controls.file.setValue(data);
      this.parsing = false;
    }
  }
  onSubmit(formGroup) {
    this.success = 0;
    this.total = 0;
    this.failed = [];
    if (!this.importForm.valid) {
      for(let i in this.importForm.controls)
        this.importForm.controls[i].markAsTouched();
      return;
    }
    this.loading = true;
    this.total = formGroup.file.data.length;
    const apiReqs: Observable<any>[] = formGroup.file.data.map(timeEntry => {
      const dateSplit = timeEntry['Date'].split('/');
      const date = new Date(dateSplit[2], dateSplit[0], dateSplit[1]);
      const formattedDate = date.getFullYear() + '-' + ('0' + (date.getMonth())).slice(-2) + '-' + ('0' + (date.getDate())).slice(-2);
      const timeSheet: any = {
        account_id: formGroup.account_id,
        activity_id: formGroup.activity_id,
        project_id: formGroup.project_id,
        comment: timeEntry.Comment,
        worked_hours: Number(timeEntry['Hours']),
        billed_hours: Number(timeEntry['Hours']),
        date: formattedDate
      };
      return this.timesheetService.createTimesheet(timeSheet)
        .pipe(catchError(error => {
          this.failed.push(timeEntry);
          return of(null);
        }));
    });
    const req1 = apiReqs.splice(0, 1);
    req1[0].pipe(merge(...apiReqs, 5)).subscribe(res => {
      if (res) {
        this.success++;
      }
      if (this.total === this.success + this.failed.length) {
        this.loading = false;
        this.importForm.reset({
          'account_id': this.currentUser.id,
          'project_id': '',
          'activity_id': '',
        });

      }
    });
  }
  downloadFailed() {
    const file = this.papa.unparse(this.failed, {
      header: true
    });
    const fileName = 'failed_timesheet_import_' + new Date().toISOString() + '.csv';
    this.openSaveFileDialog(file, fileName, 'text/csv');
  }
  private openSaveFileDialog (data, filename, mimetype) {

    if (!data) return;

    const blob = data.constructor !== Blob
      ? new Blob([data], {type: mimetype || 'application/octet-stream'})
      : data ;

    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, filename);
      return;
    }

    const lnk = document.createElement('a');
    const url = window.URL;
    let objectURL;

    if (mimetype) {
      lnk.type = mimetype;
    }

    lnk.download = filename || 'untitled';
    lnk.href = objectURL = url.createObjectURL(blob);
    lnk.dispatchEvent(new MouseEvent('click'));
    setTimeout(url.revokeObjectURL.bind(url, objectURL));

  }
}




// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/timesheets/import-timesheet/import-timesheet.component.ts